module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrapper"
  }, [_c('div', {
    staticClass: "zb-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": "local_video"
    }
  }), _vm._v(" "), (_vm.show_svga) ? _c('playSvga', {
    ref: "svga"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06850c3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tengxunyunzb/tengxunyunzb.vue
// module id = 791
// module chunks = 1